// action
import {
    CANCEL_APPOINTMENT,
    CANCEL_APPOINTMENT_FAIL,
    CANCEL_APPOINTMENT_SUCCESS,
    CANCEL_APPOINTMENT_RESET
} from '../action/cancelAppointmentAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case CANCEL_APPOINTMENT:
            return {
                ...state,
                apiState: "loading"
            }
        case CANCEL_APPOINTMENT_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case CANCEL_APPOINTMENT_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
                data: action.response.data.data
            }
        case CANCEL_APPOINTMENT_RESET:
            return initialState
        default:
            return state
    }
}